export default {
    code: 'payWithPoints',
    name: 'PayWithPoints',
    description: 'Pay With Points',
    payWithPointsEntries: [
        {
            discount: {
                currencyIso: 'EUR',
                formattedValue: '€0.00',
                priceType: 'BUY',
                value: 0.0,
            },
            points: 0,
        },
        {
            discount: {
                currencyIso: 'EUR',
                formattedValue: '€30.00',
                priceType: 'BUY',
                value: 30.0,
            },
            points: 100,
        },
        {
            discount: {
                currencyIso: 'EUR',
                formattedValue: '€60.00',
                priceType: 'BUY',
                value: 60.0,
            },
            points: 200,
        },
        {
            discount: {
                currencyIso: 'EUR',
                formattedValue: '€90.00',
                priceType: 'BUY',
                value: 90.0,
            },
            points: 300,
        },
    ],
    position: 0,
};
